export enum MY_POOL_DETAIL_TABS {
  EARNINGS = 'Earnings',
  SHARE = 'Share',
}
